import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';
import React from 'react';
import { parseTradeline } from './AccountMixTradeline';
import { formatAsCompleteMonthAndYear } from 'helpers/dateHelper';
import './AccountMixTradeline.scss';
import {
  TradelineNotification,
  TradelineHeader,
  BureauBalanceAndRefreshButtonTableComponent,
} from '../Components/FactorTradelineBaseComponents';
import { isPremium, isFreeTrial, isPlus1B } from 'helpers/userHelper';
import { getSimplifiedDate } from 'helpers/dateHelper';
import { providerMapping } from 'customHelpersPath/factorMapping.helper';
import { canPurchase3BReport } from 'pages_CreditReportTU/creditReportTU3B.helper';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

const AccountMixTradeLineComponent = props => {
  const {
    tradeline,
    userInfo,
    selectedBureau,
    profileContainer,
    creditReports,
  } = props;
  const creditProfileRefreshDate =
    profileContainer?.modules[0]?.additionalData?.creditProfileRefreshDate;
  const isPremiumUser = isPremium(userInfo) && !isFreeTrial(userInfo);
  const isDownloadAvailable = canPurchase3BReport({
    userInfo,
    creditReportRes: creditReports,
  });
  const is1B = isPlus1B(userInfo);
  const parsedTradeline = parseTradeline(tradeline, selectedBureau);
  const refreshDate = new Map([
    [ALL, getSimplifiedDate(new Date())],
    [TRANS_UNION, getSimplifiedDate(new Date())],
    [EQUIFAX, getSimplifiedDate(creditProfileRefreshDate?.equifax)],
    [EXPERIAN, getSimplifiedDate(creditProfileRefreshDate?.experian)],
  ]);
  const titleStyle = () => {
    return 'bold';
  };
  return (
    <FlexContainer
      className={
        'tradelineContainer bgWhite flex-column grayShadow16 margt16 padlr30 padb24 padt30 m-padt18 m-pad10 border-rad8px'
      }
    >
      <TradelineHeader
        titleStyle={titleStyle}
        title={parsedTradeline?.creditor}
        subtitle={
          'Date Opened: ' +
          formatAsCompleteMonthAndYear(parsedTradeline?.dateOpened)
        }
        basedOnBureauLabel={
          'Based on ' +
          providerMapping.get(selectedBureau) +
          ' report from ' +
          refreshDate.get(selectedBureau)
        }
        accountAmmount={'$' + parsedTradeline?.dueAmount?.toLocaleString()}
        statusLabel={'Balance'}
      />
      <FlexContainer className={'flex-column'}>
        <BureauBalanceAndRefreshButtonTableComponent
          is1B={is1B}
          bureauBalance={parsedTradeline?.bureauBalance}
          isDownloadAvailable={isDownloadAvailable}
          isPremiumUser={isPremiumUser}
          selectedBureau={selectedBureau}
        />
      </FlexContainer>
      {!parsedTradeline?.dontShowMessage && (
        <TradelineNotification parsedTradeline={parsedTradeline} />
      )}
    </FlexContainer>
  );
};

export { AccountMixTradeLineComponent };
